import { render } from "./FinalSlide.vue?vue&type=template&id=a3de47e0&scoped=true"
import script from "./FinalSlide.vue?vue&type=script&lang=js"
export * from "./FinalSlide.vue?vue&type=script&lang=js"

import "./FinalSlide.vue?vue&type=style&index=0&id=a3de47e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3de47e0"]])

export default __exports__